<template>
  <md-modal-dialog @close="onClose"
    @md-clicked-outside="$modal.cancel('backdrop click')"
    @keydown.esc="$modal.cancel('ESC keypress')">
    <md-dialog-title>
      <div>
        <b>Session expired</b>
      </div>
      <md-subheader>
        <md-icon class="md-size-2x">warning</md-icon>&nbsp;&nbsp;&nbsp;
        Looks like your session has expired, please login again.
      </md-subheader>
    </md-dialog-title>
    <md-dialog-actions>
      <md-button class="md-primary md-flat" @click="redirectToLogin">Login</md-button>
    </md-dialog-actions>
  </md-modal-dialog>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    onClose(event) {
      event.preventDefault();
    },
    redirectToLogin() {
      window.location.href = '/login';
    },
  },
};
</script>

<style lang="scss" scoped>
.md-subheader {
  margin: 15px 15px -5px;
  padding: 0px;
}
</style>
